/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */

/**
 * @namespace Phaser.Utils.String
 */

module.exports = {

    Format: require('./Format'),
    Pad: require('./Pad'),
    Reverse: require('./Reverse'),
    UppercaseFirst: require('./UppercaseFirst')

};



//////////////////
// WEBPACK FOOTER
// ./utils/string/index.js
// module id = 986
// module chunks = 0